export default __webpack_public_path__ + "static/media/app2.d368c396.png";